<template>
  <div class="w-100">
    <!-- Navigation and related information START -->
    <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0">
      <interview-navi :navData="pageData"></interview-navi>
    </div>
    <div role="main" :class="{'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus}">

      <form-notifications :pageData="pageData"></form-notifications>

      <!-- TOP Instruction SECTION -->
      <div class="d-flex justify-content-center mx-auto mb-1" v-if="blurbs.formtop && blurbs.formtop.visible">
        <div class="alert alert-primary my-0 py-2 w-50" role="note">
          <div class="row no-gutters">
            <div class="d-inline-block pr-2 my-auto">
              <img width="25px" height="25px" src="../../../../assets/info-circle-blue.svg" alt="info">
            </div>
            <div class="col d-inline-block my-auto smaller-font-content" v-html="blurbs.formtop.content">
            </div>
          </div>
        </div>
      </div>
      <!-- TOP Instruction SECTION END -->

      <div class="row no-gutters mx-0">
        <div class="col-12">
          <form class="needs-validation" @keydown.enter.prevent="submitted">
            <div class="form-row mx-0">
              <!--LEFT COL-->
              <div class="col-12 col-md-6 px-0">
                <div v-if="hasFields(colsArray[0], pageFieldsArray)" class="mr-md-4 shadow-sm pb-2 rounded">
                  <!--SECTION HEADER-->
                  <div class="py-2 pl-2 mt-1 mb-2 text-white bg-ltblue rounded-top" role="heading" aria-level="3">
                    {{ colsArray[0] }}</div>
                  <!--FORM BLOCK-->
                  <form-block v-for="(item, key) in pageFieldsArray" :key='key' v-if="item.section === colsArray[0]"
                    :formdata='item' :class="getFieldCss(item)"></form-block>
                </div>
              </div>

              <!--RIGHT COL-->
              <div class="col-12 col-md-6 px-0">
                <div v-if="hasFields(colsArray[1], pageFieldsArray)" class="ml-md-4 shadow-sm pb-2 rounded">
                  <!--SECTION HEADER-->
                  <div class="py-2 pl-2 mt-1 mb-2 text-white bg-ltblue rounded-top" role="heading" aria-level="3">
                    {{ colsArray[1] }}</div>
                  <!--FORM BLOCK-->
                  <form-block v-for="(item, key) in pageFieldsArray" :key='key' v-if="item.section === colsArray[1]"
                    :formdata='item' :class="getFieldCss(item)"></form-block>
                </div>
              </div>
            </div>

            <hr />
            <!-- bottom Instruction SECTION -->
            <div class="d-flex justify-content-center mx-auto mt-3"
              v-if="blurbs.formbottom && blurbs.formbottom.visible">
              <div class="alert alert-primary my-0 py-2 w-50" role="note">
                <div class="row no-gutters">
                  <div class="d-inline-block pr-2 my-auto">
                    <img width="25px" height="25px" src="../../../../assets/info-circle-blue.svg" alt="info">
                  </div>
                  <div class="col d-inline-block my-auto smaller-font-content" v-html="blurbs.formbottom.content">
                  </div>
                </div>
              </div>
            </div>
            <!-- bottom Instruction SECTION END -->

            <div class="form-row justify-content-center mx-0 my-3"
              v-if="getContinueLabelName() != '' && continueEnabled">
              <div class="col-8 text-center">
                <button type="submit" class="btn btn-primary"
                  @click.prevent="submitted">{{ getContinueLabelName() }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <dev-auto-fill :pageData="pageData"></dev-auto-fill>
    <!-- Bound Policy Alert -->
    <form-alerts
      v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status === 'Bound'"
      :pageData="policyBindError" :class="{'policy-bound-alert': true, 'margin-25' : quotePanelStatus}"></form-alerts>
  </div>
</template>

<script>
import FormBlock from '../../../presentational/FormBlock';
import FormAlerts from '../../../presentational/alerts/FormAlerts';
import FormNotifications from '../../../presentational/alerts/FormNotifications';
import InterviewNavigation from '../../shared/Navigation';
import InterviewNavigationTitle from '../../shared/NavigationTitle';
import fetchData from '../../../../services/fetchData';
import common from '../../../../services/common';
import { rulesMixin } from '../../../../mixins/rulesMixin';
import { pageMixin } from '../../../../mixins/pageMixin';
import { stickyDivMixin } from '../../../../mixins/stickyDivMixin';

export default {
  mixins: [pageMixin, rulesMixin, stickyDivMixin],
  data() {
    return {
      pageFieldsArray: [],
      blurbs: [],
      colsArray: [],
      pageData: {
        page_name: '',
        buttons: [],
        fields: [],
        blurbs: [],
        quote_summary: {},
      },
    };
  },
  components: {
    FormBlock,
    FormAlerts,
    FormNotifications,
    interviewNavi: InterviewNavigation,
    interviewNaviTitle: InterviewNavigationTitle,
  },
  methods: {
    /**
     * check if inline fields available to display. Add class accordingly
     */
    getFieldCss(data) {
      let formClassSize = {};
      const formType = data.field_type;
      const formLayout = formType.split('_')[2];
      if (formLayout === 'inline' || formLayout === 'right') {
        formClassSize = {
          'd-inline-block': true,
          'mx-2': true,
          'form-group': true,
        };
      } else {
        formClassSize = {
          'mx-2': true,
          'form-group': true,
        };
      }
      return formClassSize;
    },
  },
  created() {
    const requestParam = {
      url: this.$store.getters.getNavLink,
    };
    /**
     * Below is where we utilize our 'import fetchData' to get ALL the data needed to render this page:
     * multiple fields which could have values already in them from a previous session,
     * contents of Help/Script and Quote Summary, State of the navigation buttons, errors associated
     * with a specific field, and more.
     */
    const startTimeVal = (new Date()).getTime();
    fetchData.getPageData(requestParam).then((response) => {
      // log API response time through application into GA tool
      common.gapRecordAnalyticsGeneric(startTimeVal, 'API', response.data.page_name);
      this.pageData = response.data;

      this.rc2Logo();
      this.pageFieldsArray = this.pageData.fields;

      // set coliumns 1 and 2 using pageFieldsArray
      this.pageFieldsArray.forEach((element) => {
        if (!this.colsArray.find(el => el === element.section)) {
          this.colsArray.push(element.section);
        }
      });

      /**
       * Because component's data needs to be able to affect other component's
       * data, the data is stored in the Vuex state management store.
       */
      this.$store.mutatable_data = this.pageFieldsArray;

      /* collect blurb data in blurbs array based on position */
      for (let blurb = 0; blurb < this.pageData.blurbs.length; blurb += 1) {
        if (!this.blurbs[this.pageData.blurbs[blurb].location]) {
          this.blurbs[this.pageData.blurbs[blurb].location] = [];
        }
        this.blurbs[this.pageData.blurbs[blurb].location].visible = this.pageData.blurbs[blurb].visible;
        this.blurbs[this.pageData.blurbs[blurb].location].content = this.pageData.blurbs[blurb].content;
      }
      common.gapRecordAnalytics(response.data.page_name);
    });
  },
  mounted() {
    /* eslint no-undef: */
    /* eslint prefer-template:  */
  },
};
</script>

<style scoped>
/***header/footer information blurb***/
@media all and (max-width: 992px) {
  .alert.alert-primary{
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/interview/Auto/RC2/ContactDetails.vue?7145930e